import NavBar from "../components/Navbar/NavBar"
import { Helper } from "../static/helper"
import Footer from "../components/Footer"
import ScrollToTop from '../components/ScrollToTop';

export const ConsultationPourquoi = () => {

    const webSite = () => {
        window.open(Helper.urlReservation)
    }

    return <>
        <div>
            <NavBar />
        </div>

        <ScrollToTop>

        <div className="min-h-screen bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 lg:pt-32 pb-12">

                <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 lg:p-12">
                    <h1 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-2xl sm:text-3xl lg:text-4xl text-center mb-4">
                        Pour quel motif nous consulter ?
                    </h1>

                    <p className="text-gray-600 text-base sm:text-lg text-center mb-8 leading-relaxed">
                        Le chiropracteur dispose de nombreux outils qu'il adaptera en fonction du patient et de la raison de sa consultation.
                    </p>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div className="space-y-3">
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                <span className="text-green-500 mt-0.5 text-lg">✓</span>
                                <span className="text-gray-700">Douleur au dos (cou, dos et bas du dos)</span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                <span className="text-green-500 mt-0.5 text-lg">✓</span>
                                <span className="text-gray-700">Sciatique et cruralgie</span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                <span className="text-green-500 mt-0.5 text-lg">✓</span>
                                <span className="text-gray-700">Lumbago (blocage aigu du bas du dos)</span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                <span className="text-green-500 mt-0.5 text-lg">✓</span>
                                <span className="text-gray-700">Torticolis (blocage aigu du cou)</span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                <span className="text-green-500 mt-0.5 text-lg">✓</span>
                                <span className="text-gray-700">Douleurs aux hanches ou bassin</span>
                            </div>
                        </div>
                        <div className="space-y-3">
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                <span className="text-green-500 mt-0.5 text-lg">✓</span>
                                <span className="text-gray-700">Douleurs cervico-brachiales</span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                <span className="text-green-500 mt-0.5 text-lg">✓</span>
                                <span className="text-gray-700">Céphalées (maux de tête)</span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                <span className="text-green-500 mt-0.5 text-lg">✓</span>
                                <span className="text-gray-700">Vertiges d'origine cervicale</span>
                            </div>
                            <div className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl">
                                <span className="text-green-500 mt-0.5 text-lg">✓</span>
                                <span className="text-gray-700">Douleur de la mâchoire (SADAM)</span>
                            </div>
                        </div>
                    </div>

                    <p className="text-gray-600 text-base sm:text-lg mt-8 text-center font-medium">
                        N'hésitez pas à nous contacter pour tout renseignement.
                    </p>

                    <div className="flex justify-center mt-8">
                        <button style={{ background: Helper.footerBackGroundColor }} className="text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:opacity-90 transition-opacity" onClick={webSite}>
                            Prendre rendez-vous
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <Footer />

        </ScrollToTop>
    </>
}
